<template>
  <div class="step-settings">
    <p class="hint">{{ $t('bo.programs.creation.settingsHint') }}</p>

    <!-- Les deux methodes (comme a la creation d'un programme d'entreprise dans l'application). -->
    <label class="option-card" :class="{ selected: store.pairingMethod === 'both' }">
      <input
        type="radio"
        name="pairing"
        value="both"
        :checked="store.pairingMethod === 'both'"
        :disabled="store.isArchivedProgram"
        @change="store.pairingMethod = 'both'"
      />
      <div>
        <div class="option-title">{{ $t('bo.programs.creation.bothMethods') }}</div>
        <div class="option-text">{{ $t('bo.programs.creation.bothMethodsDesc') }}</div>
      </div>
    </label>

    <label class="option-card" :class="{ selected: store.pairingMethod === 'admin_assigned' }">
      <input
        type="radio"
        name="pairing"
        value="admin_assigned"
        :checked="store.pairingMethod === 'admin_assigned'"
        :disabled="store.isArchivedProgram"
        @change="store.pairingMethod = 'admin_assigned'"
      />
      <div>
        <div class="option-title">{{ $t('bo.programs.creation.weAssignMentors') }}</div>
        <div class="option-text">{{ $t('bo.programs.creation.weAssignMentorsDesc') }}</div>
      </div>
    </label>

    <label class="option-card" :class="{ selected: store.pairingMethod === 'user_initiated' }">
      <input
        type="radio"
        name="pairing"
        value="user_initiated"
        :checked="store.pairingMethod === 'user_initiated'"
        :disabled="store.isArchivedProgram"
        @change="store.pairingMethod = 'user_initiated'"
      />
      <div>
        <div class="option-title">{{ $t('bo.programs.creation.participantsChoose') }}</div>
        <div class="option-text">{{ $t('bo.programs.creation.participantsChooseDesc') }}</div>
      </div>
    </label>
  </div>
</template>

<script setup>
import { useAdminProgramCreationStore } from '@/stores/adminProgramCreation'

const store = useAdminProgramCreationStore()
</script>

<style scoped>
.step-settings {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.hint {
  margin: 0;
  color: #6b7280;
  font-size: 0.875rem;
}

.option-card {
  display: flex;
  gap: 0.75rem;
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  cursor: pointer;
  background: #fafafa;
}

.option-card.selected {
  border-color: #3b82f6;
  background: #eff6ff;
}

.option-title {
  font-weight: 600;
  color: #1f2937;
  font-size: 0.9rem;
}

.option-text {
  margin-top: 0.25rem;
  color: #6b7280;
  font-size: 0.85rem;
}
</style>
